import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Box, SxProps, Theme } from '@mui/material';

import React, { useState } from 'react';
import { Storage } from 'aws-amplify';
import ProfilePicture from '../../atoms/ProfilePicture';
import { BucketImage } from '../../../../hooks/useBucketImage';

const SelectAvatarDialog = (props: {
	onSelect: (value: BucketImage | undefined) => void;
	triggerSx?: SxProps<Theme>;
}) => {
	React.useEffect(() => {
		Storage.list('avatars/').then((response) => {
			const files: BucketImage[] = response.results
				.filter((currentValue) => {
					return currentValue.size && currentValue.key;
				})
				.map((file) => {
					return { key: file.key ?? '', level: 'public' };
				});
			setAvatarList(files);
		});
	}, []);
	const [avatarDialogOpen, setAvatarDialogOpen] = useState(false);
	const [selectedAvatar, setSelectedAvatar] = useState<BucketImage>();
	const [avatarList, setAvatarList] = useState<BucketImage[]>([]);
	console.log('avatar is', selectedAvatar);

	const handleConfirm = () => {
		props.onSelect(selectedAvatar);
		setAvatarDialogOpen(false);
	};

	return (
		<>
			<Button
				variant="outlined"
				onClick={() => setAvatarDialogOpen(true)}
				sx={{ textTransform: 'none', ...props.triggerSx }}
			>
				Pick from our gallery
			</Button>
			<Dialog open={avatarDialogOpen} onClose={() => setAvatarDialogOpen(false)}>
				<DialogTitle>Select an Avatar</DialogTitle>
				<DialogContent>
					<Box display={'flex'} flexWrap={'wrap'} gap={2} justifyContent={'center'}>
						{avatarList.map((avatar) => {
							return (
								<ProfilePicture
									key={avatar.key}
									image={avatar}
									sx={{
										width: '4rem',
										height: '4rem',
										borderStyle: 'solid',
										borderWidth: selectedAvatar === avatar ? 3 : 0,
										borderColor: '#002868'
									}}
									onClick={() => setSelectedAvatar(avatar)}
								></ProfilePicture>
							);
						})}
					</Box>
				</DialogContent>
				<DialogActions>
					<Button sx={{ textTransform: 'none' }} onClick={() => setAvatarDialogOpen(false)}>
						Cancel
					</Button>
					<Button sx={{ textTransform: 'none' }} onClick={handleConfirm} variant={'contained'}>
						Confirm
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
export default SelectAvatarDialog;
